import { OhsUser } from 'user/OhsUser';
import { getWorkplaceOptions } from 'user/OhsUserServices';

export default class OhsCorrespondenceFilterModels {
  viewPreset?: 'view_1' | 'view_2' | 'view_3';

  archived: boolean;

  sort: string;

  workplaces: string[];

  tableSortKeyLists: {
    sortColAscDescOptions: { name: string; value: string }[];
  };

  constructor(user?: OhsUser) {
    this.viewPreset = undefined;
    this.archived = false;
    this.workplaces = [];
    this.tableSortKeyLists = {
      sortColAscDescOptions: [
        { name: 'Title: A to Z', value: '{ "key": "title", "order": 1 }' },
        { name: 'Title: Z to A', value: '{ "key": "title", "order": -1 }' },
        { name: 'Date Created: Newest to Oldest', value: '{ "key": "dateCreated", "order": -1 }' },
        { name: 'Date Created: Oldest to Newest', value: '{ "key": "dateCreated", "order": 1 }' },
        { name: 'Created Order: Newest to Oldest', value: '{ "key": "_id", "order": -1 }' },
        { name: 'Created Order: Oldest to Newest ', value: '{ "key": "_id", "order": 1 }' },
      ],
    };
    this.sort = '{ "key": "dateCreated", "order": -1 }';

    if (user) {
      const getWorkplaceLists = getWorkplaceOptions(user.configs);
      const workplaceOptions = getWorkplaceLists.map((list: any) => list.id);
      this.workplaces = workplaceOptions;
    }
  }
}
